import type React from 'react'
import Skeleton from 'react-loading-skeleton'
import * as S from './Minisearch.styles'

const EditorialCardSkeleton: React.FC = () => {
  return (
    <S.Card>
      <div style={{ aspectRatio: '16/10', width: '100%' }}>
        <Skeleton style={{ width: '100%', height: '100%' }} />
      </div>
      <div>
        <Skeleton width="80%" height="1.8rem" />
      </div>
    </S.Card>
  )
}

export const EditorialCardsSkeleton: React.FC = () => {
  return (
    <S.SuggestionsContainer className="main">
      <S.TitleContainer>
        <h2>
          <Skeleton width="200px" height="2rem" />
        </h2>
      </S.TitleContainer>
      <S.CardsContainer
        role="region"
        tabIndex={0}
        aria-label="Editorial content loading"
      >
        {Array.from({ length: 4 }).map((_, index) => (
          <EditorialCardSkeleton key={index} />
        ))}
      </S.CardsContainer>
    </S.SuggestionsContainer>
  )
}
